import { Button } from "@/components/ui/button";
import heroImg from "@/assets/hero-conflict.jpg";
import logo from "@/assets/mesamind-logo.svg";

const HeroSection = () => (
  <section className="relative min-h-screen flex items-center">
    <div className="absolute inset-0">
      <img
        src={heroImg}
        alt="Negociação entre sócios"
        className="w-full h-full object-cover"
        width={1920}
        height={1080}
        fetchPriority="high"
        decoding="async"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-surface-darker/95 via-surface-darker/80 to-surface-darker/40" />
    </div>
    <div className="relative z-10 container mx-auto px-6 py-20">
      <div className="max-w-2xl">
        <a href="https://mesamind.com" target="_blank" rel="noopener noreferrer" className="inline-block mb-8">
          <img src={logo} alt="Mesamind" className="h-10" />
        </a>
        <h1 className="text-[28px] md:text-[37px] lg:text-[48px] font-heading font-bold leading-[1.2em] tracking-[-1px] text-surface-darker-foreground mb-6">
          Quando o conflito entre sócios trava decisões, o risco não é o negócio.{" "}
          <span className="text-gradient-amber">É o legado.</span>
        </h1>
        <p className="text-[16px] md:text-[18px] text-surface-dark-foreground/80 mb-4 font-body font-normal leading-[1.5em]">
          Destrave decisões críticas, reconstrua acordos entre sócios e evite conflitos irreversíveis.
        </p>
        <p className="text-[14px] md:text-[16px] text-surface-dark-foreground/60 mb-10 font-body font-normal leading-[1.5em]">
          Intermediação estruturada, confidencial e independente para sócios de empresas.
        </p>
        <Button variant="cta" size="xl" asChild>
          <a href="#contato">Quero uma conversa confidencial</a>
        </Button>
      </div>
    </div>
  </section>
);

export default HeroSection;
